import { checkStatus, parseJSON } from '@rsos/utils';
import { getAPIHost } from '@rsos/utils/metaTags';
import fetchRetry from '../fetchRetry';
import { UPDATE_INTEGRATION_CREDENTIAL_SUCCESS } from './types';

const baseURL = `${getAPIHost()}/v1/capstone`;

export const updateIntegrationCredentialSuccess = payload => ({
  type: UPDATE_INTEGRATION_CREDENTIAL_SUCCESS,
  payload,
});

/**
 * @param {String} orgID - sinatra org id
 * @param {Object} updatedCredential - user's input data from formik
 */

export const updateIntegrationCredential =
  (orgID, updatedCredential) => async dispatch => {
    const id = updatedCredential.internal_id;
    try {
      return await fetchRetry(
        `${baseURL}/psaps/${orgID}/authority-credentials/${id}`,
        {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(updatedCredential),
        },
      )
        .then(checkStatus)
        .then(parseJSON)
        .then(response => {
          dispatch(updateIntegrationCredentialSuccess(updatedCredential));
          return response;
        });
    } catch (error) {
      return error;
    }
  };

export default updateIntegrationCredential;
